import React from 'react';

export default function SpiLegend(props) {
  const legend_defs = {
    "title": "Standardized Precipitation Index (SPI) Categories",
    "href": "https://www.nrcc.cornell.edu",
    "text": "Northeast Regional Climate Center"
  };
  
  return (
      <table className="mapLegend-container" summary="Legend for point value markers on map">
        <tbody>
          <tr>
            <th colSpan="12">{legend_defs.title}</th>
          </tr>
          <tr>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d4"></div></td>
            <td className="mapLegend-value-container"><b>D4</b>: &lt;-2.0</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d3"></div></td>
            <td className="mapLegend-value-container"><b>D3</b>: -2.0 to -1.6</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d2"></div></td>
            <td className="mapLegend-value-container"><b>D2</b>: -1.6 to -1.3</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d1"></div></td>
            <td className="mapLegend-value-container"><b>D1</b>: -1.3 to -0.8</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d0"></div></td>
            <td className="mapLegend-value-container"><b>D0</b>: -0.8 to -0.5</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-dnada"></div></td>
            <td className="mapLegend-value-container">-0.5 to 0.5</td>

          </tr>
          <tr>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w0"></div></td>
            <td className="mapLegend-value-container"><b>W0</b>: 0.5 to 0.8</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w1"></div></td>
            <td className="mapLegend-value-container"><b>W1</b>: 0.8 to 1.3</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w2"></div></td>
            <td className="mapLegend-value-container"><b>W2</b>: 1.3 to 1.6</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w3"></div></td>
            <td className="mapLegend-value-container"><b>W3</b>: 1.6 to 2.0</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w4"></div></td>
            <td className="mapLegend-value-container"><b>W4</b>: &gt;2.0</td>
            <td className="mapLegend-icon-container"><div></div></td>
            <td className="mapLegend-value-container"></td>

          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="12">Data provided by <a href={legend_defs.href} target="_blank" rel="noreferrer">{legend_defs.text}</a>. Powered by <a href="https://www.rcc-acis.org" target="_blank" rel="noreferrer">ACIS</a>.</td>
          </tr>
        </tfoot>
      </table>
    );
}